export const SET_INDICES = 'INDICES/SET_INDICES' 